import { useContext, useState } from 'react'
import { Accordion, Button, FeatureChip, Flex, Text } from 'src/componentv2'
import ConfigurationApiContext from 'src/provider/API/v2/call-service/configuration'

/* Mapped against IBank.Shared.Application.FeatureManagement.Features.
   "Airtime Purchase" has no distinct constant in that enum — AirtimeTopup ("2")
   is the only airtime-related id. I've mapped both labels to "2" for now, which
   means toggling one will implicitly toggle the other's underlying value on
   save. Flag me if these are meant to be two different backend features and
   I'll leave "Airtime Purchase" unmapped instead. */
const FEATURES: { id: string; label: string }[] = [
    { id: '1', label: 'Local Transfer' },        // IntraBankTransfer
    { id: '2', label: 'Airtime Topup' },         // AirtimeTopup
    { id: '3', label: 'Bills Payment' },         // BillsPayment
    { id: '5', label: 'Cards' },                 // Cards
    { id: '4', label: 'Loans' },                 // Loans
    { id: '6', label: 'Fixed Deposit' },         // FixedDeposit
    { id: '9', label: 'Nqr' },                   // NQR
    { id: '11', label: 'Inter Bank Transfer' },  // InterBankTransfer
    { id: '2', label: 'Airtime Purchase' },      // see note above — same id as Airtime Topup
    { id: '16', label: 'Add account' },          // AddAccounts
]

interface Props {
    open: boolean
    onToggle: (open: boolean) => void
    onSaveAndNext: () => void
}

export const FeatureControl: React.FC<Props> = ({ open, onToggle, onSaveAndNext }) => {
    const { updateApplicationFeatures } = useContext(ConfigurationApiContext)

    const [active, setActive] = useState<Set<string>>(new Set())
    const [saving, setSaving] = useState(false)

    // No prefill: InstitutionProfileDetails doesn't carry the active feature list.

    const toggle = (id: string, checked: boolean) =>
        setActive((prev) => {
            const next = new Set(prev)
            checked ? next.add(id) : next.delete(id)
            return next
        })

    const handleSaveAndNext = async () => {
        setSaving(true)

        const result = await updateApplicationFeatures(Array.from(active))

        setSaving(false)
        if (result !== false && result !== null) {
            onSaveAndNext()
        }
    }

    return (
        <Accordion title="Feature Control" open={open} onToggle={onToggle}>
            <Text fontSize="1.4" style={{ fontFamily: 'Gilmer Medium' }} bottomMargin="1.2">
                Select Features to be active on the App
            </Text>

            <div className="business-logic__chip-grid">
                {FEATURES.map((f) => (
                    <FeatureChip
                        key={f.label}
                        label={f.label}
                        checked={active.has(f.id)}
                        onChange={(checked) => toggle(f.id, checked)}
                    />
                ))}
            </div>

            <Flex justify="flex-end" gap="1.2" topMargin="2.4" className="accordion__footer">
                <Button variant="primary" size="sm" disabled={saving} onClick={handleSaveAndNext}>
                    {saving ? 'Saving…' : 'Save & Next'}
                </Button>
            </Flex>
        </Accordion>
    )
}

export default FeatureControl